<script lang="ts">
  import i18n from '../../i18n'
  import AuthLayout from '../../components/auth-layout/AuthLayout.svelte'
  import { usePageTitle } from '../../hooks/page-title'
  import { logoDarkFull, logoLightFull } from '../../assets/images'
  import { goToAuthPortal } from '../../helpers/oauth'

  usePageTitle($i18n.t('signin.metaTitle'))
</script>

<AuthLayout title={$i18n.t('signin.title')}>
  <button class="sign-in-button" onclick={goToAuthPortal} data-testid="oauth-signin">
    {$i18n.t('signin.signInWithC3D')}
    <img
      src={logoLightFull}
      class="dark-hidden"
      alt={$i18n.t('authLayout.logoAlt')}
    />
    <img
      src={logoDarkFull}
      class="light-hidden"
      alt={$i18n.t('authLayout.logoAlt')}
    />
  </button>
</AuthLayout>

<style lang="scss">
  .sign-in-button {
    border: 1px solid var(--grid-stroke);
    background: var(--background);
    color: var(--foreground);
    padding: .5rem 1rem;
    border-radius: .25rem;
    display: flex;
    flex-direction: row;
    gap: .5rem;
    align-items: center;
    cursor: pointer;
    transition: all .3s ease;

    &:hover {
      background: var(--grid-stroke);
    }

    img {
      height: 2.5rem;
      width: 2.5rem;
      object-fit: contain;
    }
  }
</style>
